/* eslint-disable @typescript-eslint/no-unused-vars */

export const groupStyle = ({ palette = {} }) => ({
  // The last column should expand to fill entire browser.
  '& .other-group-container': {
    overflow: 'hidden',
    '& .flex-cell:last-child': {
      flexGrow: 1,
      maxWidth: 10000,
      borderRight: 'none !important',
    },
  },

  '& .freezing-group-container': {
    flexGrow: 0,
    '& .freezing-group-container': {
      flexGrow: 0,
    },
  },

  '& div:not(:last-child).nested-column-container': {
    flexGrow: '0 !important',
  },
});
